import React, { useState, useEffect } from "react";
import { Box, TextField, Typography } from "@mui/material";
import "./Edit.css"; // Using your shared CSS file

const EditParameter = ({ open, onClose, parameter, onSave }) => {
  const [formData, setFormData] = useState({
    display_name: "",
    key_name: "",
  });

  const [errors, setErrors] = useState({});


  const displayNameRegex = /^[A-Za-z0-9]+( [A-Za-z0-9]+)*$/;
  const keyNameRegex = /^[A-Za-z_-]{4,12}$/;
  const onlyNumbersRegex = /^[0-9]+$/;

  useEffect(() => {
  if (open && parameter) {
    setFormData({
      display_name: parameter.display_name || "",
      key_name: parameter.key_name || "",
    });

    // ✅ RESET ERRORS WHEN OPEN
    setErrors({});
  }

  // ✅ ALSO RESET WHEN CLOSED
  if (!open) {
    setFormData({
      display_name: "",
      key_name: "",
    });
    setErrors({});
  }
}, [open, parameter]);


  useEffect(() => {
    if (parameter) {
      setFormData({
        display_name: parameter.display_name || "",
        key_name: parameter.key_name || "",
      });
    }
  }, [parameter]);

 const handleChange = (e) => {
  const { name, value } = e.target;

  let updatedValue = value;

  // ✅ Fix spaces for display name
  if (name === "display_name") {
    updatedValue = value
      .replace(/\s+/g, " ")   // multiple → single space
      .replace(/^\s/, "");    // remove starting space
  }

  // ✅ Remove spaces for key name
  if (name === "key_name") {
    updatedValue = value.replace(/\s/g, "");
  }

  setFormData((prev) => ({
    ...prev,
    [name]: updatedValue
  }));

  // ✅ Runtime validation
  let error = "";

  if (name === "display_name") {
    if (!updatedValue) {
      error = "Display name is required";
    } else if (updatedValue.length < 2 || updatedValue.length > 20) {
      error = "Must be 2–20 characters";
     } else if (onlyNumbersRegex.test(updatedValue)) {
      error = "Cannot be only numbers";
    } else if (!displayNameRegex.test(updatedValue)) {
      error =
        "Only letters & numbers, single spaces, no leading/trailing spaces";
    }
  }

  if (name === "key_name") {
    if (!updatedValue) {
      error = "Key name is required";
    } else if (!keyNameRegex.test(updatedValue)) {
      error =
        "4–12 chars, lowercase only, allowed: _ and - (no spaces)";
    }
  }

  setErrors((prev) => ({
    ...prev,
    [name]: error
  }));
};



 
 const handleSubmit = (e) => {
  e.preventDefault();

  const newErrors = {};

  Object.keys(formData).forEach((key) => {
    const value = formData[key];
    let error = "";

    if (key === "display_name") {
      if (!value) error = "Display name is required";
      else if (value.length < 2 || value.length > 20)
        error = "Must be 2–20 characters";
      else if (!displayNameRegex.test(value))
        error =
          "Only letters & numbers, no leading/trailing spaces";
    }

    if (key === "key_name") {
      if (!value) error = "Key name is required";
      else if (!keyNameRegex.test(value))
        error =
          "4–12 chars, lowercase only, allowed: _ and - (no spaces)";
    }

    if (error) newErrors[key] = error;
  });

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) return;

  onSave({ ...parameter, ...formData });
};

  if (!open) return null;

  return (
    <div className="edit-site-modal">
      <Box component="form" className="edit-site-container edit-site-form" onSubmit={handleSubmit}>
        <Typography className="edit-site-title">Edit Parameter</Typography>

        <TextField
          label="Display Name"
          name="display_name"
          value={formData.display_name}
          onChange={handleChange}
          error={!!errors.display_name}
          helperText={errors.display_name || ""}
          placeholder="e.g. Battery Voltage"
        />

        <TextField
          label="Key Name"
          name="key_name"
          value={formData.key_name}
          onChange={handleChange}
          // error={!!errors.key_name}
          // helperText={errors.key_name || "Database key (lowercase, no spaces)"}
          placeholder="e.g. batt_v"
          disabled
        />

        <div className="edit-btn-wrapper">
          <button type="button" className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="edit-btn">
            Save Changes
          </button>
        </div>
      </Box>
    </div>
  );
};

export default EditParameter;